import { Dispatch, SetStateAction } from 'react'
import { useHistory } from 'react-router'
import {
  BUTTON_SIZE,
  slideSideAnimationVariants,
} from '@npco/zeller-design-system'

import { ROUTE } from 'const/routes'
import { TransferStateCondition as Condition } from 'pages/Transfer/states/TransferState/TransferStateCondition'
import {
  TransferContactState,
  TransferGeneralState,
  TransferZellerState,
} from 'pages/Transfer/Transfer.stateMachine'
import { useTransferActionEvents } from 'pages/Transfer/TransferFields/TransferActionButtons/TransferActionButtons.hooks'
import { StyledActionButtonsWrapper } from 'pages/Transfer/TransferFields/TransferActionButtons/TransferActionButtons.styled'
import { TransferSubmitButton } from 'pages/Transfer/TransferFields/TransferSubmitButton/TransferSubmitButton'
import {
  ActionButtons,
  StyledCloseButton,
  StyledNextButton,
} from 'components/Buttons/ActionButtonsGroup/ActionButtonsGroup.styled'
import { ButtonBack } from 'components/Buttons/ButtonBack'
import { page, shared } from 'translations'

import { useTransferState } from '../../Transfer.context'
import {
  getIsOnSendingState,
  getIsOnSummaryState,
} from './TransferActionButtons.utils'

const FINISHED_STATES = [
  `${TransferGeneralState.ZellerTransfer}.${TransferZellerState.Complete}`,
  `${TransferGeneralState.ContactTransfer}.${TransferContactState.Complete}`,
  `${TransferGeneralState.BpayTransfer}.${TransferContactState.Complete}`,
]

interface TransferActionButtonsProps {
  setContactValidationError: Dispatch<SetStateAction<string | undefined>>
  handleNewTransfer: () => void
}

export const TransferActionButtons = ({
  setContactValidationError,
  handleNewTransfer,
}: TransferActionButtonsProps) => {
  const history = useHistory()
  const {
    transferState: [state],
  } = useTransferState()

  const { sendBackEvent } = useTransferActionEvents()

  const isOnSummaryState = getIsOnSummaryState(state)
  const isOnSendingState = getIsOnSendingState(state)

  return (
    <StyledActionButtonsWrapper>
      <Condition
        excludedStates={FINISHED_STATES}
        animationVariants={slideSideAnimationVariants}
      >
        <ActionButtons>
          <TransferSubmitButton
            setContactValidationError={setContactValidationError}
          />
          <ButtonBack
            onClick={sendBackEvent}
            label={isOnSummaryState ? shared.edit : undefined}
            disabled={isOnSendingState}
          />
        </ActionButtons>
      </Condition>

      <Condition
        allowedStates={FINISHED_STATES}
        animationVariants={slideSideAnimationVariants}
      >
        <ActionButtons>
          <StyledNextButton fullWidth onClick={handleNewTransfer}>
            {page.transfer.newTransfer}
          </StyledNextButton>
          <StyledCloseButton
            dataTestId="close-button"
            size={BUTTON_SIZE.LARGE}
            onClick={() => history.push(ROUTE.PORTAL_ACCOUNTS)}
          >
            {shared.close}
          </StyledCloseButton>
        </ActionButtons>
      </Condition>
    </StyledActionButtonsWrapper>
  )
}
